import React from 'react';
import Logo from './Assets/logo.png';

import './Header.css'

const Header = () => {

    const handleLogoClick = () => {
        
    }

    return (
        <header className="header">
            <div className="header_logo">
                <img
                    src={Logo}
                    onClick={handleLogoClick}
                    alt="HomeApp Logo"
                    className="header_logo_image"
                />
            </div>

            <nav className="header_nav">
                <ul className="header_nav_list">
                    <li className="header_nav_item">
                        <a href="#features">Features</a>
                    </li>
                    <li className="header_nav_item">
                        <a href="#howitworks">How It Works</a>
                    </li>
                    <li className="header_nav_item">
                        <a href="#download">Download</a>
                    </li>
                </ul>
            </nav>
        </header>
    );
};

export default Header;
